enum Env {
  MASTER = 'us-master',
  PROD = 'prod',
  STAGING = 'us-staging',
  UAT = 'us-uat',
  LOCALHOST = 'localhost',
}

function getEnvironmentFromUrl(url: string) {
  if (url.includes(Env.LOCALHOST)) {
    return Env.LOCALHOST;
  }
  if (url.includes('.gladly.com')) {
    return Env.PROD;
  }
  if (url.includes('.gladly.qa')) {
    if (url.includes(Env.UAT)) {
      return Env.UAT;
    } else if (url.includes(Env.MASTER)) {
      return Env.MASTER;
    } else if (url.includes(Env.STAGING)) {
      return Env.STAGING;
    }
    return Env.UAT;
  }
  return Env.PROD;
}

const GladOsEnvs = {
  [Env.MASTER]: 'https://us-master.gladly.qa',
  [Env.PROD]: 'https://us-1.gladly.com',
  [Env.STAGING]: 'https://us-staging.gladly.qa',
  [Env.UAT]: 'https://us-uat.gladly.qa',
  [Env.LOCALHOST]: 'http://localhost:3005',
};

export function getGladOsOrigin(url: string) {
  const env = getEnvironmentFromUrl(url);
  if (env === Env.LOCALHOST) {
    return new URL(GladOsEnvs[env]).origin;
  }
  return new URL(url).origin;
}
